<div
    class="bottom-banner__wrapper"
    [class._active]="showBanner"
>
    <div
        #user="user"
        class="bottom-banner container"
        [class._show]="showBanner"
        lsUser
    >
        <ng-container *lsUiNgLet="user.userLoadingStatus$ | async as userStatus">
            @if (userStatus === UserViewStatuses.LOADED || userStatus === UserViewStatuses.NO_USER) {
                <ng-container
                    #bannerV2="bannerV2"
                    [location]="userStatus === UserViewStatuses.LOADED ? 'bottom-logged-banner' : 'bottom-banner'"
                    [saveBannerInCookies]="true"
                    lsBannerV2
                    (lsOnCloseBanner)="closeBanner()"
                >
                    <ng-container *ngIf="bannerV2.items$ | async as banners">
                        @if (banners[0]) {
                            <ng-container
                                *ngTemplateOutlet="bannerContent; context: {
                            banner: banners[0]
                        }"
                            ></ng-container>
                        } @else {
                            <div class="bottom-banner__fixed-action">
                                <ls-scroll-to-top></ls-scroll-to-top>
                                <ls-fixed-action></ls-fixed-action>
                            </div>
                        }
                    </ng-container>
                    <ng-template
                        #bannerContent
                        let-banner="banner"
                    >
                        <div
                            class="bottom-banner__content"
                            [style.background]="banner.metadata?.['bg']"
                        >
                            <div class="bottom-banner__image">
                                @if (banner.image?.backgroundDesk) {
                                    <picture class="bottom-banner__bg">
                                        <source
                                            [srcset]="(minioUrl | resolveMinioUrlMirror)  + banner.image.backgroundDesk + '.webp'"
                                            type="image/webp"
                                        >
                                        <source
                                            [srcset]="(minioUrl | resolveMinioUrlMirror)  + banner.image.backgroundDesk + '.png'"
                                            type="image/png"
                                        >
                                        <img
                                            class="bottom-banner__bg-img"
                                            [src]="(minioUrl | resolveMinioUrlMirror)  + banner.image.backgroundDesk + '.png'"
                                            alt=""
                                            draggable="false"
                                        >
                                    </picture>
                                }
                                @if (banner.image?.characterDesk) {
                                    <picture class="bottom-banner__character">
                                        <source
                                            [srcset]="(minioUrl | resolveMinioUrlMirror) + banner.image.characterDesk + '.webp'"
                                            type="image/webp"
                                        >
                                        <source
                                            [srcset]="(minioUrl | resolveMinioUrlMirror) + banner.image.characterDesk + '.png'"
                                            type="image/png"
                                        >
                                        <img
                                            class="bottom-banner__character-img"
                                            [src]="(minioUrl | resolveMinioUrlMirror) + banner.image.characterDesk + '.png'"
                                            alt=""
                                            draggable="false"
                                        >
                                    </picture>
                                }
                            </div>

                            <div class="bottom-banner__text">
                                <p
                                    *ngIf="banner.texts | contentTextByName : 'title'"
                                    class="bottom-banner__title _system-sub-xs _800"
                                    [style.color]="(banner.texts | contentTextByName : 'title')?.color"
                                >
                                    {{ (banner.texts | contentTextByName : 'title')?.text! | translate }}
                                </p>
                                <p
                                    *ngIf="banner.texts | contentTextByName : 'subtitle'"
                                    class="bottom-banner__subtitle _system-sub-md _800"
                                    [style.color]="(banner.texts | contentTextByName : 'subtitle')?.color"
                                >
                                    {{ (banner.texts | contentTextByName : 'subtitle')?.text! | translate }}
                                </p>
                            </div>

                            <div class="bottom-banner__actions">
                                @if (banner.metadata?.['button'] === "deposit" || !banner.metadata?.['button']) {
                                    <button
                                        *ngIf="banner.texts | contentTextByName : 'button'"
                                        class="bottom-banner__btn"
                                        [lsUiButtonPalette]="banner.buttonColor ? (banner.buttonColor | fixButtonPalette) : 'accent-1'"
                                        lsUiButtonKind="primary"
                                        lsUiButtonSize="small"
                                        (click)="userStatus===UserViewStatuses.LOADED ? openCashier() : openRegistration()"
                                    >
                                        {{ (banner.texts | contentTextByName : 'button')?.text! | translate }}
                                    </button>

                                    <a
                                        class="bottom-banner__link"
                                        (click)="userStatus===UserViewStatuses.LOADED ? openCashier() : openRegistration()"
                                    ></a>
                                }
                                @if (banner.metadata?.['button'] === "play") {
                                    <a
                                        *ngIf="banner.texts | contentTextByName : 'button'"
                                        class="bottom-banner__btn"
                                        [lsUiButtonPalette]="banner.buttonColor ? (banner.buttonColor | fixButtonPalette) : 'accent-1'"
                                        [routerLink]="['/game' | localize, banner.metadata?.['game']]"
                                        lsUiButtonKind="primary"
                                        lsUiButtonSize="small"
                                    >
                                        {{ (banner.texts | contentTextByName : 'button')?.text! | translate }}
                                    </a>

                                    <a
                                        class="bottom-banner__link"
                                        [routerLink]="['/game' | localize, banner.metadata?.['game']]"
                                    ></a>
                                }
                                @if (banner.metadata?.['button'] === "wheel") {
                                    <button
                                        *ngIf="banner.texts | contentTextByName : 'button'"
                                        class="bottom-banner__btn"
                                        [lsUiButtonPalette]="banner.buttonColor ? (banner.buttonColor | fixButtonPalette) : 'accent-1'"
                                        lsUiButtonKind="primary"
                                        lsUiButtonSize="small"
                                        (click)="userStatus===UserViewStatuses.LOADED ? openWheel() : openRegistration()"
                                    >
                                        {{ (banner.texts | contentTextByName : 'button')?.text! | translate }}
                                    </button>

                                    <a
                                        class="bottom-banner__link"
                                        (click)="userStatus===UserViewStatuses.LOADED ? openWheel() : openRegistration()"
                                    ></a>
                                }
                            </div>
                            <button
                                class="bottom-banner__close"
                                (click)="bannerV2.closeBanner(banner.id, banner.metadata?.['period'])"
                            >
                                <ls-ui-icon
                                    height="24"
                                    src="close"
                                    width="24"
                                ></ls-ui-icon>
                            </button>
                        </div>

                        <div class="bottom-banner__fixed-action _mob">
                            <ls-scroll-to-top></ls-scroll-to-top>
                            <ls-fixed-action></ls-fixed-action>
                        </div>
                    </ng-template>
                </ng-container>
            }
        </ng-container>
    </div>
    <div class="bottom-banner__fixed-action _desk">
        <ls-scroll-to-top></ls-scroll-to-top>
        <ls-fixed-action></ls-fixed-action>
    </div>
</div>
